import type MatchPlanModel from 'tio-data/models/match-plan';

export function getTranslationKeyForReportedSalaryForMatchPlan(matchPlan: MatchPlanModel) {
  const key = (matchPlan.qualifyingIncome || '').split('.').pop()?.toLowerCase() || 'unknown';
  return `syf.qualifying_income.${key}`;
}

export default null; // silence a false warning
